function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}><path d="M13.43 12.32l-3.14-3.4 3.15-3.45A1 1 0 1 0 12 4.13L9 7.45 6 4.32a1 1 0 1 0-1.43 1.36l3 3.25-3 3.29a1 1 0 0 0 .73 1.68 1 1 0 0 0 .7-.33l2.9-3.17 3 3.28a1 1 0 1 0 1.46-1.36z" fill="currentColor" /></svg>;
});